// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"32":"dumi__theme__layouts__GlobalLayout","96":"dumi__theme__layouts__DocLayout","448":"dumi__pages__Demo"}[chunkId] + "." + {"32":"ffb3182a","96":"8881dc80","448":"c05cf747"}[chunkId] + ".chunk.css";
};